import { render, staticRenderFns } from "./CartWatchCustom.vue?vue&type=template&id=485ed1e2&scoped=true"
import script from "./CartWatchCustom.vue?vue&type=script&lang=js"
export * from "./CartWatchCustom.vue?vue&type=script&lang=js"
import style0 from "./CartWatchCustom.vue?vue&type=style&index=0&id=485ed1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ed1e2",
  null
  
)

export default component.exports